import {
  PRESENTISMO_LOADING,
  PRESENTISMO_SUCCESS,
  PRESENTISMO_ERROR,
  PRESENTISMO_RESET,
} from "../../ActionTypes";

import axiosLogin from "global/helpers/axiosLogin";

export const wsGetPresentismoDetalle =
  (flgConsulta, idPacFamiliar, nextStep) => (dispatch) => {
    dispatch({
      type: PRESENTISMO_LOADING,
    });
    axiosLogin().then((respuesta) => {
      respuesta
        .get(
          `/his/turnos/presentismoDetalle/${flgConsulta}${
            idPacFamiliar ? `/${idPacFamiliar}` : ""
          }`,
        )
        .then((resp) => {
          dispatch({
            type: PRESENTISMO_SUCCESS,
            payload: resp.data,
          });
          if (nextStep) nextStep(true, resp.data);
        })
        .catch((err) => {
          dispatch({ type: PRESENTISMO_ERROR, payload: err.data });
          if (nextStep) nextStep(false, err.response.data);
        });
    });
  };

export const resetPresentismo = () => (dispatch) => {
  dispatch({
    type: PRESENTISMO_RESET,
  });
};
